import ViewportMixin from '../../mixins/viewport';
import transition from '../../mixins/transition';

export default {
  name: 'Sidebar',
  mixins: [ViewportMixin, transition],
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Boolean,
    title: {
      type: String,
      default: '',
    },
    outsideClose: {
      type: Boolean,
      default: true,
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
    containerStyle: {
      type: [Object, String, Array],
      required: false,
      default: '',
    },
    contentPadding: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modal: false,
      dialogContainerStyle: { padding: '0' },
    };
  },
  watch: {
    value: function (value) {
      value ? this.openModal() : this.closeModal();
    },
    modal: function (value) {
      this.$emit('change', value);
    },
  },
  mounted() {
    this.value ? this.openModal() : this.closeModal();
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    beforeHide() {
      this.$emit('before-hide');
    },
    show() {
      this.$emit('show');
    },
    beforeShow() {
      this.$emit('before-show');
    },
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
  },
};
